import React from "react";

const Pagination = ({ currentPage, totalPages, changePage }) => {
  const pages = [];

  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    //Si hay más de 5 páginas, siempre mostramos las dos primeras páginass
    pages.push(1, 2);
  
    if (currentPage > 3) {
      pages.push("...");
    }
  
    //Rango de páginas que vamos a mostrar 
    const start = Math.max(3, currentPage - 1);
    const end = Math.min(totalPages - 2, currentPage + 1);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
  
    if (currentPage < totalPages - 2) {
      pages.push("...");
    }
  
    pages.push(totalPages - 1, totalPages);
  }

  const uniquePages = [...new Set(pages)];

  return (
    <div className="flex items-center justify-center border-collapse">
      <button
        onClick={() => changePage(currentPage - 1)}
        disabled={currentPage === 1}
        className={`${
          currentPage === 1
            ? "border-[#E5E7EB] h-[33px] px-2 border-[1px] text-blue text-sm font-itcbook cursor-not-allowed"
              : "text-blue px-2 h-[33px] border-[1px] border-[#E5E7EB] text-sm font-itcbook"
        }`}
      >
        Anterior
      </button>

      {uniquePages.map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === "number" && changePage(page)}
          className={`${
            currentPage === page
              ? "bg-blue w-[33px] h-[33px] border-blue border-[1px] text-white text-sm font-itcbook"
                : "text-blue font-itcbook w-[33px] h-[33px] text-sm border-[#E5E7EB] border-[1px]"
          }`}
          disabled={typeof page !== "number"}
        >
          {page === "..." ? "..." : page}
        </button>
      ))}

      <button
        onClick={() => changePage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 ${
          currentPage === totalPages
            ? "border-[#E5E7EB] hidden h-[33px] px-2 border-[1px] text-blue text-sm font-itcbook cursor-not-allowed"
              : "text-blue  border-[#E5E7EB] font-itcbook text-sm border-[1px] h-[33px]"
        }`}
      >
        Siguiente
      </button>
    </div>
  );
};

export default Pagination;
